import { render, staticRenderFns } from "./transrecorditem.vue?vue&type=template&id=7c25a706&scoped=true"
import script from "./transrecorditem.vue?vue&type=script&lang=js"
export * from "./transrecorditem.vue?vue&type=script&lang=js"
import style0 from "./transrecorditem.vue?vue&type=style&index=0&id=7c25a706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c25a706",
  null
  
)

export default component.exports